import { useEffect, useState } from "react";

export function useIsMobilePortrait(maxWidth = 768): boolean {
  const [isMobilePortrait, setIsMobilePortrait] = useState(false);

  useEffect(() => {
    const check = () => {
      const mobileApprox = window.innerWidth <= maxWidth;
      const portrait = window.matchMedia("(orientation: portrait)").matches;
      setIsMobilePortrait(mobileApprox && portrait);
    };

    // Run once on mount
    check();

    // Re-run on resize or orientation change
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);

    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, [maxWidth]);

  return isMobilePortrait;
}